import { useRef } from 'react';

/**
 * Referenced from react-aria selection management:
 * https://github.com/adobe/react-spectrum/blob/main/packages/%40react-aria/selection/src/useTypeSelect.ts
 */
const DEBOUNCE_WAIT_MS = 1000;
function useTypeKeySearch(_ref) {
  let {
    onTypeKeySearch
  } = _ref;
  const state = useRef({
    search: "",
    timeout: -1
  }).current;
  const onKeyDown = e => {
    const character = getStringForKey(e.key);
    if (!character || e.ctrlKey || e.metaKey || !e.currentTarget.contains(e.target) ||
    // not consider spacebar as a search key since it conflicts with spacebar selection
    character === " ") {
      return;
    }
    state.search += character;
    if (onTypeKeySearch) {
      onTypeKeySearch(state.search);
    }
    clearTimeout(state.timeout);
    state.timeout = window.setTimeout(() => {
      state.search = "";
    }, DEBOUNCE_WAIT_MS);
  };
  return {
    // Using a capturing listener to catch the keydown event before
    // other hooks in order to handle the Spacebar event.
    onKeyDownCapture: onKeyDown
  };
}
function getStringForKey(key) {
  // If the key is of length 1, it is an ASCII value.
  // Otherwise, if there are no ASCII characters in the key name,
  // it is a Unicode character.
  // See https://www.w3.org/TR/uievents-key/
  if (key.length === 1 || !/^[A-Z]/i.test(key)) {
    return key;
  }
  return "";
}

export { useTypeKeySearch };
